import { z } from 'zod'
import { fileSchema } from '../file-schema'

export const documentFieldSchemas = {
  bank_statement: z
    .custom((val) => val instanceof File, { message: 'Debes adjuntar un archivo' })
    .pipe(fileSchema),
  csf: z.union([z.null(), fileSchema]),
  card: z
  .custom((val) => val instanceof File, { message: 'Debes adjuntar un archivo' })
  .pipe(fileSchema),
}
